// source: pbtypes/gen/vehicle_updates/ota_progress.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_vehicle_updates_ota_status_pb = require('../../../pbtypes/gen/vehicle_updates/ota_status_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_updates_ota_status_pb);
var pbtypes_gen_vehicle_updates_transfer_rate_pb = require('../../../pbtypes/gen/vehicle_updates/transfer_rate_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_updates_transfer_rate_pb);
goog.exportSymbol('proto.vehicle_updates.OtaProgress', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vehicle_updates.OtaProgress = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vehicle_updates.OtaProgress.repeatedFields_, null);
};
goog.inherits(proto.vehicle_updates.OtaProgress, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vehicle_updates.OtaProgress.displayName = 'proto.vehicle_updates.OtaProgress';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vehicle_updates.OtaProgress.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vehicle_updates.OtaProgress.prototype.toObject = function(opt_includeInstance) {
  return proto.vehicle_updates.OtaProgress.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_updates.OtaProgress} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_updates.OtaProgress.toObject = function(includeInstance, msg) {
  var f, obj = {
utime: jspb.Message.getFieldWithDefault(msg, 1, 0),
status: jspb.Message.getFieldWithDefault(msg, 2, 0),
progress: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
errorText: jspb.Message.getFieldWithDefault(msg, 4, ""),
transferRatesList: jspb.Message.toObjectList(msg.getTransferRatesList(),
    pbtypes_gen_vehicle_updates_transfer_rate_pb.TransferRate.toObject, includeInstance),
currentReleaseKey: jspb.Message.getFieldWithDefault(msg, 6, ""),
toReleaseKey: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_updates.OtaProgress}
 */
proto.vehicle_updates.OtaProgress.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vehicle_updates.OtaProgress;
  return proto.vehicle_updates.OtaProgress.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_updates.OtaProgress} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_updates.OtaProgress}
 */
proto.vehicle_updates.OtaProgress.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readSint64());
      msg.setUtime(value);
      break;
    case 2:
      var value = /** @type {!proto.vehicle_updates.OtaStatus.Enum} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setProgress(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setErrorText(value);
      break;
    case 5:
      var value = new pbtypes_gen_vehicle_updates_transfer_rate_pb.TransferRate;
      reader.readMessage(value,pbtypes_gen_vehicle_updates_transfer_rate_pb.TransferRate.deserializeBinaryFromReader);
      msg.addTransferRates(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setCurrentReleaseKey(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setToReleaseKey(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vehicle_updates.OtaProgress.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vehicle_updates.OtaProgress.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_updates.OtaProgress} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_updates.OtaProgress.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUtime();
  if (f !== 0) {
    writer.writeSint64(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getProgress();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getErrorText();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getTransferRatesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      pbtypes_gen_vehicle_updates_transfer_rate_pb.TransferRate.serializeBinaryToWriter
    );
  }
  f = message.getCurrentReleaseKey();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getToReleaseKey();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional sint64 utime = 1;
 * @return {number}
 */
proto.vehicle_updates.OtaProgress.prototype.getUtime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_updates.OtaProgress} returns this
 */
proto.vehicle_updates.OtaProgress.prototype.setUtime = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional OtaStatus.Enum status = 2;
 * @return {!proto.vehicle_updates.OtaStatus.Enum}
 */
proto.vehicle_updates.OtaProgress.prototype.getStatus = function() {
  return /** @type {!proto.vehicle_updates.OtaStatus.Enum} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.vehicle_updates.OtaStatus.Enum} value
 * @return {!proto.vehicle_updates.OtaProgress} returns this
 */
proto.vehicle_updates.OtaProgress.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional double progress = 3;
 * @return {number}
 */
proto.vehicle_updates.OtaProgress.prototype.getProgress = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vehicle_updates.OtaProgress} returns this
 */
proto.vehicle_updates.OtaProgress.prototype.setProgress = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string error_text = 4;
 * @return {string}
 */
proto.vehicle_updates.OtaProgress.prototype.getErrorText = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.vehicle_updates.OtaProgress} returns this
 */
proto.vehicle_updates.OtaProgress.prototype.setErrorText = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated TransferRate transfer_rates = 5;
 * @return {!Array<!proto.vehicle_updates.TransferRate>}
 */
proto.vehicle_updates.OtaProgress.prototype.getTransferRatesList = function() {
  return /** @type{!Array<!proto.vehicle_updates.TransferRate>} */ (
    jspb.Message.getRepeatedWrapperField(this, pbtypes_gen_vehicle_updates_transfer_rate_pb.TransferRate, 5));
};


/**
 * @param {!Array<!proto.vehicle_updates.TransferRate>} value
 * @return {!proto.vehicle_updates.OtaProgress} returns this
*/
proto.vehicle_updates.OtaProgress.prototype.setTransferRatesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.vehicle_updates.TransferRate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle_updates.TransferRate}
 */
proto.vehicle_updates.OtaProgress.prototype.addTransferRates = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.vehicle_updates.TransferRate, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_updates.OtaProgress} returns this
 */
proto.vehicle_updates.OtaProgress.prototype.clearTransferRatesList = function() {
  return this.setTransferRatesList([]);
};


/**
 * optional string current_release_key = 6;
 * @return {string}
 */
proto.vehicle_updates.OtaProgress.prototype.getCurrentReleaseKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.vehicle_updates.OtaProgress} returns this
 */
proto.vehicle_updates.OtaProgress.prototype.setCurrentReleaseKey = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string to_release_key = 7;
 * @return {string}
 */
proto.vehicle_updates.OtaProgress.prototype.getToReleaseKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.vehicle_updates.OtaProgress} returns this
 */
proto.vehicle_updates.OtaProgress.prototype.setToReleaseKey = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


goog.object.extend(exports, proto.vehicle_updates);
